import React from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import styled from 'styled-components';
import { SectionModule } from '../../../../api/models/BibleStudyModule';
import { StudySectionModuleCard } from './StudySectionModuleCard';

type Props = {
  id: string;
  modules: SectionModule[];
  userClickedEditModule?: (moduleDayIndex: number) => void;
  userClickedDeleteModule?: (moduleDayIndex: number) => void;
  userReOrderedModule?: (module: SectionModule, dir: 'up' | 'down') => void;
};

/**
 * List of Bible Study Modules that is drag-n-drop ready
 * @param props
 * @returns
 */
export const StudySectionModuleCards = (props: Props) => {
  const modules = [...props.modules].sort((a, b) => a.sortOrder - b.sortOrder);
  return (
    <Droppable droppableId={props.id} type="droppableSubItem">
      {droppableProvided => (
        <StudySectionModuleCardsDiv ref={droppableProvided.innerRef} {...droppableProvided.droppableProps}>
          {modules.map((module, index) => {
            return (
              <Draggable key={module.moduleType + index} draggableId={module.moduleType + index} index={index}>
                {draggableProvided => (
                  <div
                    ref={draggableProvided.innerRef}
                    key={module.moduleType + index}
                    {...draggableProvided.draggableProps}>
                    <StudySectionModuleCard
                      module={module}
                      dragHandleProps={draggableProvided.dragHandleProps}
                      {...(props.userClickedEditModule && {
                        onEditClick: () => props.userClickedEditModule?.(index),
                      })}
                      {...(props.userClickedDeleteModule && {
                        onDeleteClick: () => props.userClickedDeleteModule?.(index),
                      })}
                      onReOrderClick={dir => props.userReOrderedModule?.(module, dir)}
                    />
                  </div>
                )}
              </Draggable>
            );
          })}
          {droppableProvided.placeholder}
        </StudySectionModuleCardsDiv>
      )}
    </Droppable>
  );
};

export const StudySectionModuleCardsDiv = styled.div`
  margin-top: 1rem;
  & > :not(:last-child) {
    margin-bottom: 13px;
  }
`;
